import Blocks from "components/Blocks";
import AppLayout from "layouts/AppLayout";
import Loader from "components/Loader";
import SearchBox from "components/Header/SearchBox";
import useUser from "context/hooks/user";
// import { t } from "i18next";
import { useTenant } from "context/tenantProvider";
import { updateUserVisit } from "api/user";
import { useEffect } from "react";

const Home = () => {
  const { isLoading } = useUser();
  const { isLoading: tenantLoading } = useTenant();

  useEffect(() => {
    updateUserVisit();
  }, []);

  if (tenantLoading || isLoading) return <Loader open={true} />;

  return (
    <AppLayout>
      <Loader open={isLoading} />
      <section className="first-screen"></section>
      {/* <div className="bg-theme-purple rounded-lg py-6 px-5 mt-4 mx-4  relative block md:hidden">
        <h2 className="text-white text-3xl font-bold max-w-[140px]">
          {t('discoverYourFuture')}
        </h2>
        <img
          src={require("assets/images/hero.png")}
          className={`h-[172px] absolute -top-4 -right-4 block md:hidden`}
        />
      </div> */}
      <div className="mt-6 mx-4 block md:hidden">
        <SearchBox />
      </div>
      <Blocks />
    </AppLayout>
  );
};

export default Home;
